<template>
  <section>
      <website ref="website"/>
      <div class="name">
        <div class="letter">
          <img src="/static/img/web/lil1.png" class="letter-image">
        </div>
      </div>
      <br/>

      <div class="shopify-section index-section">
        <div class="collection-box" id="carousel-1599149564459" data-section-id="1599149564459"
             data-section-type="carousel">
          <div class="section-header text-center wow fadeIn" style="visibility: visible; animation-name: fadeIn;">

            <h2 class="h2">ETHNIC CLOTHING</h2>
          </div>

<!--          <div class="">-->
            <div class="grid carousel slick-initialized slick-slider">
              <div aria-live="polite" class="slick-list draggable">
                <div class="slick-track" role="listbox"
                     style="opacity: 1; width: 1254px; transform:translate3d(0px, 0px, 0px);">
                  <div class="p-grid">
                    <div class="collection-grid-item p-col">
                      <a @click="viewProductByGroupId(531,'subGroup')" href="" class="collection-grid-item__link">
                        <img class="lazyautosizes lazyloaded" src="/static/img/web/Kurta_Sets_540x.png"/>
                        <div class="collection-grid-item__title-wrapper"/>
                      </a>

                    </div>
                    <div class="collection-grid-item p-col">
                      <a @click="viewProductByGroupId(542,'subGroup')" href="" class="collection-grid-item__link">
                        <img class="lazyautosizes lazyloaded" src="/static/img/web/Lehenga_Sets_540x.png"/>
                        <div class="collection-grid-item__title-wrapper"/>
                      </a>

                    </div>

                    <!-- </div> -->

                    <!-- <div class="p-col-12 p-md-4"> -->

                    <div class="collection-grid-item p-col">
                      <a @click="viewProductByGroupId(541,'subGroup')" href="" class="collection-grid-item__link">
                        <img class="lazyautosizes lazyloaded" src="/static/img/web/Sharara_Sets_540x.png"/>
                        <div class="collection-grid-item__title-wrapper"/>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <br/>
      <br/>
      <div class="name">
        <div class="letter">
          <img src="/static/img/web/new.png" class="letter-image">
        </div>
      </div>


      <!-- <div class="section-header text-center wow fadeIn" style="visibility: visible; animation-name: fadeIn;">
      <h2 class="h2">SHOP BY CATEGORY</h2>
      </div>
      <div class="card" >
          <DataView :value="displayItemList" :paginator="true" class="grid grid--uniform grid-products grid--view-items" style="width: 100%;margin-top: 3%;margin-left: 13%" :rows="3" :layout="layout">
            <template #grid="slotProps">
               <div class="p-col-12 p-md-3" style="border-bottom: 0px solid #c8c8c8;">
                 <div class="productList">
                  <div class="grid__item small--one-half medium--one-third large-up--one-quarter">
                  <div class="grid-view-item style1 wow fadeIn">
                  <div class="grid-view_image">
                    <a href="" >
                      <img  @click="viewProductDetailsPage(slotProps.data)" :src="slotProps.data.singleImageUrl" :alt="slotProps.data.name" style="height: 370px;width: 90%;"/></a>
                    <div style="margin: 2% 0%;" class="grid-view-item__title">{{slotProps.data.name}}</div>
                    <span class="product-price__price" >Rs.{{slotProps.data.salesRate}}</span>
                    <div class="product-description">{{slotProps.data.description}}</div>
                  </div>
                  </div>
                  </div>
              </div>
               </div>
            </template>
          </DataView>
        </div>
        <br/> -->

      <div class="shopify-section index-section">
        <div class="collection-box" id="carousel-1599149564459" data-section-id="1599149564459"
             data-section-type="carousel">
          <div class="section-header text-center wow fadeIn" style="visibility: visible; animation-name: fadeIn;">

            <h2 class="h2">SHOP BY CATEGORY</h2>
          </div>

            <div class="grid carousel slick-initialized slick-slider">
              <div aria-live="polite" class="slick-list draggable">
                <div class="slick-track" role="listbox"
                     style="opacity: 1; width: 1254px; transform:translate3d(0px, 0px, 0px);">
                  <div class="p-grid">
                    <div class="collection-grid-item p-col">
                      <a @click="viewProductByGroupId(547,'subGroup')" href="" class="collection-grid-item__link">
                        <img class="lazyautosizes lazyloaded" src="/static/img/web/dresses_540x.png"/>


                        <div class="collection-grid-item__title-wrapper"/>

                      </a>

                    </div>
                    <!-- </div> -->
                    <!-- <div class="p-col-12 p-md-4"> -->

                    <div class="collection-grid-item p-col">
                      <a @click="viewProductByGroupId(546,'subGroup')" href="" class="collection-grid-item__link">
                        <img class="lazyautosizes lazyloaded" src="/static/img/web/Jumpsuits_540x.png"/>


                        <div class="collection-grid-item__title-wrapper"/>

                      </a>

                    </div>

                    <!-- </div> -->

                    <!-- <div class="p-col-12 p-md-4"> -->

                    <div class="collection-grid-item p-col">
                      <a @click="viewProductByGroupId(538,'subGroup')" href="" class="collection-grid-item__link">
                        <img class="lazyautosizes lazyloaded" src="/static/img/web/CO-ORD_SETS_540x.png"/>


                        <div class="collection-grid-item__title-wrapper"/>

                      </a>

                    </div>

                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>


      <div class="name">
        <div class="letter">
          <img src="/static/img/web/onthego.png" class="letter-image">
        </div>
      </div>
      <!-- <div class="section-header text-center wow fadeIn" style="visibility: visible; animation-name: fadeIn;">
     <h2 class="h2">BEST SELLERS</h2>
     </div>  -->

      <!-- <div class="card" >
       <DataView :value="displayItemList" :paginator="true" class="grid grid--uniform grid-products grid--view-items" style="width: 100%" :rows="4" :layout="layout">
         <template #grid="slotProps">
            <div class="p-col-12 p-md-3" style="border-bottom: 0px solid #c8c8c8;">
              <div class="productList">
               <div class="grid__item small--one-half medium--one-third large-up--one-quarter">
               <div class="grid-view-item style1 wow fadeIn">
               <div class="grid-view_image">
                 <a href="" >
                   <img  @click="viewProductDetailsPage(slotProps.data)" :src="slotProps.data.singleImageUrl" :alt="slotProps.data.name" style="height: 400px;width: 90%;"/></a>
                 <div style="margin: 2% 0%;" class="grid-view-item__title">{{slotProps.data.name}}</div>
                 <span class="product-price__price" >Rs.{{slotProps.data.salesRate}}</span>
                 <div class="product-description">{{slotProps.data.description}}</div>
               </div>
               </div>
               </div>
           </div>
            </div>
         </template>
       </DataView>
     </div> -->

      <div class="shopify-section index-section">
        <div class="collection-box" id="carousel-1599149564459" data-section-id="1599149564459"
             data-section-type="carousel">
          <div class="section-header text-center wow fadeIn" style="visibility: visible; animation-name: fadeIn;">

            <h2 class="h2">SHOP BY AGE</h2>
          </div>

            <div class="grid carousel slick-initialized slick-slider">

              <div aria-live="polite" class="slick-list draggable">
                <div class="slick-track" role="listbox"
                     style="opacity: 1; width: 1254px; transform:translate3d(0px, 0px, 0px);">
                  <div class="p-grid">
                    <div class="collection-grid-item p-col">
                      <a @click="viewProductByGroupId(546, 'subGroup')" href="" class="collection-grid-item__link">
                        <img class="lazyautosizes lazyloaded" src="/static/img/web/baby_1_540x.jpg"/>


                        <div class="collection-grid-item__title-wrapper"/>

                      </a>

                    </div>
                    <!-- </div> -->
                    <!-- <div class="p-col-12 p-md-4"> -->

                    <div class="collection-grid-item p-col">
                      <a @click="viewProductByGroupId(604, 'group')" href="" class="collection-grid-item__link">
                        <img class="lazyautosizes lazyloaded" src="/static/img/web/kids_1_540x.jpg"/>


                        <div class="collection-grid-item__title-wrapper"/>

                      </a>

                    </div>

                    <!-- </div> -->

                    <!-- <div class="p-col-12 p-md-4"> -->

                    <div class="collection-grid-item p-col">
                      <a @click="viewProductByGroupId(604, 'group')" href="" class="collection-grid-item__link">
                        <img class="lazyautosizes lazyloaded" src="/static/img/web/tweens_1_540x.jpg"/>


                        <div class="collection-grid-item__title-wrapper"/>

                      </a>

                    </div>

                  </div>


                </div>
              </div>


              <div class="shopify-section index-section">
                <div class="collection-box" id="carousel-1599149564459" data-section-id="1599149564459"
                     data-section-type="carousel">
                  <div class="section-header text-center wow fadeIn"
                       style="visibility: visible; animation-name: fadeIn;">

                    <h2 class="h2">BEST SELLERS</h2>
                  </div>

                  <div class="card">
                    <Carousel :value="displayItemList" :numVisible="4" :numScroll="1"
                              :responsiveOptions="responsiveOptions" :circular="true" :autoplayInterval="3000">
                      <template #item="slotProps">
                        <div style="border-bottom: 0px solid #c8c8c8;">
                          <div class="productList">
                            <div class="grid__item small--one-half medium--one-third large-up--one-quarter">
                              <div class="grid-view-item style1 wow fadeIn">
                                <div class="grid-view_image">
                                  <a href="">
                                    <img @click="viewProductDetailsPage(slotProps.data)"
                                         :src="slotProps.data.singleImageUrl" :alt="slotProps.data.name"
                                         style="height: 400px;width: 100%;"/></a>
                                  <div style="margin: 2% 0%;" class="grid-view-item__title">{{ slotProps.data.name }}
                                  </div>
                                  <span class="product-price__price">Rs.{{ slotProps.data.salesRate }}</span>
                                  <div class="product-description">{{ slotProps.data.description }}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </Carousel>
                  </div>

                </div>
              </div>


            </div>
          </div>
        </div>

      <br/>
      <footerWebsite ref="footerWebsite"/>
    <!-- </form> -->
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import Checkbox from 'primevue/checkbox'
import DatePicker from 'vue2-datepicker'
import Carousel from 'primevue/carousel'
import DataView from 'primevue/dataview'
import Galleria from 'primevue/galleria'
import AutoComplete from 'primevue/autocomplete'
import InputNumber from 'primevue/inputnumber'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'
import accountMasterDialog from '../accountDialog/AccountMasterDialog'
import InputText from 'primevue/inputtext'
import TextArea from 'primevue/textarea'
import website from '../ecommerce/website.vue'
import footerWebsite from '../ecommerce/footerWebsite.vue'

export default {
  name: 'home',
  props: ['home'],
  data() {
    return {
      name: '',
      layout: 'grid',
      sortOrder: null,
      sortField: null,
      displayItemList: [],
      sortOptions: [
        {label: 'Price High to Low', value: '!price'},
        {label: 'Price Low to High', value: 'price'}
      ],
      englishDateEnabled: true,
      transactionDate: null,
      account: '',
      txnAmountDr: 0,
      txnAmountCr: 0,
      narration3: '',
      narration: '',
      drCr: '',
      drtotal: 0,
      crTotal: 0,
      difference: 0,
      chequeDate: null,
      chequeNumber: '',
      transactionDetailDTOList: [],
      transactionDeleteList: [],
      bank: false,
      editing: false,
      voucherNo: null,
      editDTO: false,
      index: null,
      tranId: null,
      tranModuleType: null,
      loading: false,
      cheque: false,
      filteredAccounts: null,
      products: null,
      responsiveOptions: [
        {
          breakpoint: '1024px',
          numVisible: 3,
          numScroll: 3
        },
        {
          breakpoint: '600px',
          numVisible: 2,
          numScroll: 2
        },
        {
          breakpoint: '480px',
          numVisible: 1,
          numScroll: 1
        }
      ]
    }
  },
  computed: {},
  mounted() {
    this.itemsList()
  },
  methods: {
    async itemsList() {
      let response = await this.$store.dispatch('loadItemMasterListFeatured')
      this.displayItemList = response.data.data
    },
    async viewProductByGroupId(id, typ) {
      let PIHdata = {
        id: id,
        type: typ
      }
      this.$router.push({name: 'collections', params: {collections: PIHdata}, query: {item: id, typ: PIHdata.type}})
    },
    async viewProductDetailsPage(data) {
      let PIHdata = {
        id: data.id,
        itemName: data.name,
        imgUrl: data.singleImageUrl,
        sellingPrice: data.salesRate,
        description: data.description,
        itemCode: data.itemCode,
        groupName: data.groupName,
        images: data.imageList
      }
      this.$router.push({name: 'Product Detail', params: {productObject: PIHdata}, query: {item: PIHdata.id}})
    }
  },
  components: {
    Dropdown,
    DatePicker,
    Checkbox,
    AutoComplete,
    InputNumber,
    InputMask,
    accountMasterDialog,
    Button,
    InputText,
    TextArea,
    Carousel,
    Galleria,
    DataView,
    website,
    footerWebsite
  }
}
</script>
<style scoped src="@../../../static/css/website.css">
</style>



// WEBPACK FOOTER //
// home.vue?6bce5566